import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaRegCalendarAlt, FaRegClock } from "react-icons/fa";
import { toast } from "react-toastify";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { IoMdArrowRoundForward } from "react-icons/io";
import defaultFoto1 from "../../../assets/img/cyber_madrasah.png";
import defaultFoto2 from "../../../assets/img/program_inovasi.png";
import defaultFoto3 from "../../../assets/img/konferensi_nasional.png";

function ListBerita() {
  const [cards, setCards] = useState([]);

  const defaultData = [
    {
      title:
        "Peluncuran Cyber Madrasah dan Madrasah Jateng Digital bersama Erlangga Edu Day",
      description:
        "Yogyakarta, 9 Agustus 2024 — Upaya percepatan digitalisasi madrasah terus diperkuat melalui Peluncuran Cyber Madrasah dan Jogja Madrasah Digital (JMD) yang dilaksanakan pada Jumat, 9 Agustus 2024. Kegiatan ini berlangsung dalam rangkaian Erlangga Edu Day dan diikuti oleh guru serta tenaga pendidik madrasah dari berbagai wilayah di Daerah Istimewa Yogyakarta. Acara ini menjadi momentum penting bagi madrasah untuk mulai mengadopsi sistem digital dalam proses pembelajaran, manajemen akademik, dan pelaksanaan ujian. Para peserta diperkenalkan langsung dengan fitur-fitur Cyber Madrasah dan JMD yang dirancang untuk mempermudah aktivitas sekolah secara lebih efektif dan efisien.Suasana kegiatan berlangsung interaktif dengan sesi pemaparan, diskusi, serta berbagi pengalaman terkait tantangan dan peluang digitalisasi di lingkungan madrasah. Guru-guru tampak antusias mengikuti setiap rangkaian acara dan menggali potensi pemanfaatan teknologi di sekolah masing-masing.Melalui peluncuran ini, diharapkan Cyber Madrasah dan Jogja Madrasah Digital dapat menjadi solusi nyata dalam mendukung transformasi digital madrasah, sekaligus meningkatkan kualitas layanan pendidikan yang adaptif terhadap perkembangan zaman",
      date: "2024-08-10T10:00:00Z",
      slug: "",
      image: defaultFoto1,
    },
    {
      title: "Peluncuran Program Inovasi Pembelajaran Berbasis Teknologi",
      description:
        "Bantul, 12 September 2024 — Dalam rangka meningkatkan kualitas pendidikan, Kementerian Pendidikan dan Kebudayaan meluncurkan Program Inovasi Pembelajaran Berbasis Teknologi. Acara ini diadakan di Jakarta dan dihadiri oleh sejumlah kepala sekolah, guru, serta penggiat pendidikan dari seluruh Indonesia.Program ini bertujuan untuk memfasilitasi guru dalam mengadopsi metode pembelajaran yang lebih interaktif dan menarik melalui pemanfaatan alat-alat teknologi. Dalam acara tersebut, para peserta mengikuti workshop tentang penggunaan aplikasi pendidikan, serta strategi pengintegrasian teknologi dalam kurikulum.Dengan adanya program ini, diharapkan para pendidik dapat mengembangkan metode pembelajaran yang tidak hanya efektif, tetapi juga relevan dengan kebutuhan siswa di era digital saat ini.",
      date: "2024-09-13T10:00:00Z",
      slug: "",
      image: defaultFoto2,
    },
    {
      title: "Konferensi Nasional Pendidikan Inklusif 2024",
      description:
        "Bantul, 25 Oktober 2024 — Konferensi Nasional Pendidikan Inklusif 2024 digelar untuk membahas berbagai aspek terkait pendidikan yang dapat diakses oleh semua kalangan. Acara ini berlangsung di Bandung dan dihadiri oleh para akademisi, praktisi pendidikan, serta perwakilan lembaga swadaya masyarakat.Selama konferensi, berbagai narasumber menyampaikan paparan mengenai kebijakan pendidikan inklusif, praktik terbaik, serta tantangan yang dihadapi dalam pelaksanaannya di lapangan. Diskusi panel yang melibatkan berbagai pihak juga menjadi sorotan, dengan harapan dapat menghasilkan rekomendasi yang konstruktif bagi pengembangan pendidikan inklusif ke depan.Acara ini diharapkan bisa mendorong kesadaran akan pentingnya pendidikan yang ramah bagi semua, serta menginspirasi lebih banyak pihak untuk turut berkontribusi dalam menciptakan lingkungan belajar yang inklusif",
      date: "2024-10-25T10:00:00Z",
      slug: "",
      image: defaultFoto3,
    },
  ];

  useEffect(() => {
    const fetchPostsData = async () => {
      try {
        const response = await axios.get(`/api_w/posts`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        if (response.data.data && response.data.data.length > 0) {
          setCards(response.data.data);
        } else {
          setCards(defaultData);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
        setCards(defaultData);
      }
    };

    fetchPostsData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString("id-ID", options);
  };

  const formatTime = (timeString) => {
    const options = {
      hour: "numeric",
      minute: "numeric",
    };
    return new Date(timeString).toLocaleTimeString("id-ID", options);
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <div className="mx-auto max-w-7xl md:px-7 lg:px-10 max-w-[1680px] md:px-6 lg:px-10">
      {/* Judul Berita */}
      <div className="my-8">
        <h5 className="text-center font-['Plus_Jakarta_Sans',sans-serif] text-[45px] font-semibold text-[#131313]">
          Berita Terbaru Madrasah Jateng Digital
        </h5>
      </div>

      {/* Daftar Berita */}
      <div className="mt-[10px] flex flex-col gap-6">
        {cards.slice(0, 3).map((berita, index) => (
          <div key={index} className="w-full">
            <div className="card-berita rounded-3xl p-3 shadow-sm">
              <div className="flex flex-col gap-4 md:flex-row">
                {/* Gambar */}
                <div className="w-full md:w-1/3">
                  <img
                    src={berita.image}
                    alt={berita.title}
                    className="h-[300px] w-full rounded-3xl object-cover"
                  />
                </div>

                {/* Konten */}
                <div className="w-full p-1 md:w-2/3">
                  <Link to={`/berita/${berita.slug}`}>
                    <h5 className="text-[25px] font-bold leading-tight text-[#242424] hover:text-[#242424]">
                      {berita.title}
                    </h5>
                  </Link>

                  <div className="text-md mt-3 whitespace-normal break-words text-justify leading-7 text-gray-800">
                    {parse(truncateText(berita.description, 1000))}
                  </div>

                  <div className="mb-2 mt-4 flex flex-wrap items-center gap-4 text-sm text-gray-700">
                    <div className="flex items-center rounded-[10px] bg-[#27AD81] px-4 py-2 text-white">
                      <FaRegCalendarAlt className="mr-1" />
                      {formatDate(berita.date)}
                    </div>

                    <div className="flex items-center">
                      <FaRegClock className="mr-1 text-[#7a7a7a]" />
                      {formatTime(berita.date)} WIB
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tombol Selengkapnya */}
      <div className="my-9 flex justify-center">
        <Link
          to="/berita"
          className="flex items-center rounded-[10px] bg-[#007A52] px-4 py-2 text-white transition-colors duration-300 hover:bg-[#007A52]"
        >
          Lihat Berita Selengkapnya
          <IoMdArrowRoundForward className="ml-2" />
        </Link>
      </div>
    </div>
  );
}

export default ListBerita;
